export default __webpack_public_path__ + "static/media/profile.b0827f6b.png";